/* eslint-disable */
import { useState, useMemo } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '../../Components/ui/card'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../Components/ui/select'
import { Input } from '../../Components/ui/input'
import { Badge } from '../../Components/ui/badge'
import { Button } from '../../Components/ui/button'
import { useRecoilValueLoadable } from 'recoil'
import { FetchFrontendLogs } from '../../store/AdminStore'
import { toast } from 'sonner'

const FrontendLogs = () => {
  const [phoneNumber, setPhoneNumber] = useState('')
  const [finalphoneNumber, setFinalPhoneNumber] = useState('')
  const { state, contents } = useRecoilValueLoadable(FetchFrontendLogs(finalphoneNumber))
  console.log('🚀 ~ FrontendLogs ~ contents:', contents)
  const logs = state === 'hasValue' && contents?.data ? JSON.parse(contents.data)?.log : []
  const [filterType, setFilterType] = useState('all')
  const [searchTerm, setSearchTerm] = useState('')
  const parsedLogs = logs

  if (state === 'loading') return <div className='p-4 text-center'>Loading logs...</div>
  if (state === 'hasError')
    return <div className='p-4 text-center text-red-500'>Error fetching logs</div>

  // Extract unique log types for the filter dropdown
  const uniqueTypes = [
    'all',
    ...Array.from(new Set(parsedLogs?.map((log) => log.logData.type))).sort(),
  ]

  // Filter and search logs based on current state
  const filteredLogs = parsedLogs?.filter((log) => {
    const matchesType = filterType === 'all' || log.logData.type === filterType
    const matchesSearch =
      searchTerm === '' ||
      Object.values(log).some((value) =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase()),
      )
    return matchesType && matchesSearch
  })

  const fetchLogs = () => {
    phoneNumber.length === 10
      ? setFinalPhoneNumber(phoneNumber)
      : toast.error('Enter 10 digit phone number')
  }

  return (
    <div className='container mx-auto p-4'>
      <h1 className='text-3xl font-bold mb-6'>Frontend Logs</h1>

      <div className='flex flex-col sm:flex-row gap-4 mb-6'>
        <Input
          placeholder='Enter phone number'
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          className='w-full flex-1 min-w-96'
          aria-label='Fetch Logs'
        />
        <Button onClick={fetchLogs}>Fetch Logs</Button>

        <Select onValueChange={setFilterType} defaultValue='all'>
          <SelectTrigger className='w-full sm:w-[180px] border'>
            <SelectValue placeholder='Filter by Type' />
          </SelectTrigger>
          <SelectContent>
            {uniqueTypes.map((type) => (
              <SelectItem key={type} value={type}>
                {/* Format type for display (e.g., "runtime-error" -> "Runtime Error") */}
                {type?.charAt(0)?.toUpperCase() + type?.slice(1)?.replace(/-/g, ' ')}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        {/* <Input
          placeholder='Search logs...'
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className='w-full flex-1 min-w-96'
          aria-label='Search logs'
        /> */}
      </div>

      <div className='grid gap-6'>
        {filteredLogs?.length === 0 ? (
          <div className='text-center text-gray-500'>No logs found matching your criteria.</div>
        ) : (
          filteredLogs?.map((log, index) => (
            <Card key={index} className='break-words'>
              <CardHeader className='flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-2 sm:space-y-0 pb-2'>
                <CardTitle className='text-lg font-medium'>
                  <Badge variant='secondary'>
                    {/* Format type for display */}
                    {log.logData.type.charAt(0).toUpperCase() +
                      log.logData.type.slice(1).replace(/-/g, ' ')}
                  </Badge>
                </CardTitle>

                {log.createdTimestemp && (
                  <div className='text-sm text-muted-foreground'>
                    {/* Format timestamp for readability */}
                    {new Date(log.createdTimestemp).toLocaleString()}
                  </div>
                )}
              </CardHeader>
              <CardContent className='grid gap-2 text-sm'>
                {Object.entries(log.logData).map(([key, value]) => {
                  if (key === 'type') return null

                  // If key is 'payload' or 'response' and value is object, format it
                  const isJsonKey = key === 'payload' || key === 'response'
                  const formattedValue =
                    isJsonKey && typeof value === 'object'
                      ? JSON.stringify(value, null, 2)
                      : String(value)

                  return (
                    <div
                      key={key}
                      className='flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-2'
                    >
                      <span className='font-semibold text-gray-700 dark:text-gray-300 min-w-[80px] capitalize'>
                        {key.replace(/([A-Z])/g, ' $1').trim()}:
                      </span>
                      <span className='flex-1 text-gray-900 dark:text-gray-100 whitespace-pre-wrap'>
                        {formattedValue}
                      </span>
                    </div>
                  )
                })}
              </CardContent>
            </Card>
          ))
        )}
      </div>
    </div>
  )
}

export default FrontendLogs
